/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_CallInputs */

const en_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How do I call the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`如何调用 ${i?.name} ${i?.action} API？`)
};

const pt_br2_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Como chamo o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cómo llamo al endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comment appeler l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wie rufe ich die ${i?.name}-${i?.action}-API auf?`)
};

const ru_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Как вызвать API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_call = /** @type {(inputs: Seo_Endpoint_Q_CallInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Come chiamo l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "How do I call the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_CallInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_call = /** @type {((inputs: Seo_Endpoint_Q_CallInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_CallInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_call(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_call(inputs)
	if (locale === "es") return es_seo_endpoint_q_call(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_call(inputs)
	if (locale === "de") return de_seo_endpoint_q_call(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_call(inputs)
	if (locale === "it") return it_seo_endpoint_q_call(inputs)
	return en_seo_endpoint_q_call(inputs)
});